import type { InvoiceSummary as InvoiceSummaryType } from "../types";

interface InvoiceSummaryProps {
  summary: InvoiceSummaryType;
}

interface SummaryCard {
  label: string;
  value: number;
  color: string; // Tailwind color classes
}

/**
 * Summary cards panel showing line-item verification counts.
 * Color-coded: green for correct, red for overcharged, amber for undercharged,
 * grey for rate not found, purple for duplicates.
 */
export default function InvoiceSummary({ summary }: InvoiceSummaryProps) {
  const cards: SummaryCard[] = [
    {
      label: "Total Lines",
      value: summary.total_lines,
      color: "bg-gray-50 border-gray-200 text-gray-900",
    },
    {
      label: "Correct",
      value: summary.correct_count,
      color: "bg-green-50 border-green-200 text-green-900",
    },
    {
      label: "Overcharged",
      value: summary.overcharged_count,
      color: "bg-red-50 border-red-200 text-red-900",
    },
    {
      label: "Undercharged",
      value: summary.undercharged_count,
      color: "bg-amber-50 border-amber-200 text-amber-900",
    },
    {
      label: "Duplicates",
      value: summary.duplicate_count,
      color: "bg-purple-50 border-purple-200 text-purple-900",
    },
    {
      label: "Rate Not Found",
      value: summary.rate_not_found_count,
      color: "bg-gray-50 border-gray-300 text-gray-700",
    },
  ];

  return (
    <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6">
      {cards.map((card) => (
        <div
          key={card.label}
          className={`rounded-lg border p-4 ${card.color}`}
        >
          <p className="text-xs font-medium uppercase tracking-wide opacity-70">
            {card.label}
          </p>
          <p className="mt-1 text-2xl font-bold">{card.value}</p>
        </div>
      ))}
    </div>
  );
}
